export const overflowTooltipSx = { background: '#121A22', borderRadius: '8px 0px 8px 8px', lineHeight: '150%' };

export const overflowArrowSx = {
  right: 0, pointerEvents: 'none', left: 'auto !important', transform: 'none !important',
  '&::before': { border: 'none', backgroundColor: 'transparent', width: 0, height: 0, borderLeft: '15px solid transparent', borderBottom: '15px solid #121A22', position: 'absolute', right: 0, left: 'auto !important', transform: 'none !important' },
};

export const overflowPopperModifiers = [{ name: 'offset', options: { offset: [-18, -9] } }];
